"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const weekDayNames = ['MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'];

const weekDay = d => {
  return d.getUTCDay() || 7;
};

const weekNumber = dateStr => {
  const date = new Date(dateStr);
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
};

const dayMs = 1000 * 60 * 60 * 24;

const calendarMonthDays = (year, month) => {
  const weeksToShow = 6;
  const items = [];
  const firstDay = new Date(Date.UTC(year, month, 1));
  const lastDay = new Date(Date.UTC(year, month + 1, 0));
  const start = -(weekDay(firstDay) - 1);
  let week = [];

  for (let i = start; items.length < weeksToShow; i++) {
    const day = new Date(Date.parse(firstDay) + i * dayMs);
    const date = day.getUTCDate();

    if (week.length === 7) {
      items.push(week);
      week = [];
    }

    week.push({
      text: date < 10 ? '0' + date : '' + date,
      value: day.toISOString().split('T')[0],
      currMonth: day.getMonth() === month
    });
  }

  return items;
};

const MonthViewHeader = _styledComponents.default.div.withConfig({
  displayName: "MonthView__MonthViewHeader",
  componentId: "a9uihm-0"
})(["border-bottom:1px solid #eee;background:#fafafa;ul{display:flex;height:48px;font-weight:400;font-size:18px;}li{align-items:center;display:flex;flex:1;justify-content:center;}"]);

const Items = _styledComponents.default.div.withConfig({
  displayName: "MonthView__Items",
  componentId: "a9uihm-1"
})(["display:flex;flex-direction:column;flex:1;"]);

const WeekNr = _styledComponents.default.div.withConfig({
  displayName: "MonthView__WeekNr",
  componentId: "a9uihm-2"
})(["min-width:calc(100% / 8);align-items:center;color:#333;cursor:pointer;display:flex;flex:1;justify-content:center;border-right:1px solid #eee;"]);

const Day = _styledComponents.default.div.withConfig({
  displayName: "MonthView__Day",
  componentId: "a9uihm-3"
})(["min-width:calc(100% / 8);align-items:center;color:#333;cursor:pointer;display:flex;flex:1;justify-content:center;transition:ease-out 0ms;", " ", " &:hover{background:#eee;}"], p => !p.currMonth && (0, _styledComponents.css)(["opacity:.5 !important;"]), p => p.selected && (0, _styledComponents.css)(["background:", " !important;color:#fff;"], p => p.theme.colors.main));

const WeekItems = _styledComponents.default.div.withConfig({
  displayName: "MonthView__WeekItems",
  componentId: "a9uihm-4"
})(["display:flex;flex-wrap:wrap;flex:1;"]);

const Week = ({
  days,
  select,
  onSelectDay,
  onSelectWeek
}) => /*#__PURE__*/_react.default.createElement(WeekItems, null, /*#__PURE__*/_react.default.createElement(WeekNr, {
  onClick: () => onSelectWeek(days)
}, weekNumber(days[0].value)), days.map(day => /*#__PURE__*/_react.default.createElement(Day, {
  key: day.value,
  currMonth: day.currMonth,
  selected: select.includes(day.value),
  onClick: () => onSelectDay(day.value)
}, day.text)));

const MonthView = ({
  className,
  month,
  year,
  select,
  onSelectDay,
  onSelectWeek
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement(MonthViewHeader, null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null), weekDayNames.map(name => /*#__PURE__*/_react.default.createElement("li", {
  key: name
}, name)))), /*#__PURE__*/_react.default.createElement(Items, null, calendarMonthDays(year, month - 1).map((week, idx) => /*#__PURE__*/_react.default.createElement(Week, {
  key: idx,
  days: week,
  select: select,
  onSelectDay: onSelectDay,
  onSelectWeek: onSelectWeek
}))));

var _default = (0, _styledComponents.default)(MonthView).withConfig({
  displayName: "MonthView",
  componentId: "a9uihm-5"
})(["background:#fff;border:1px solid #eee;display:flex;flex-direction:column;height:320px;width:640px;"]);

exports.default = _default;